import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import mixpanel from 'mixpanel-browser';
import WebFont from 'webfontloader';
import * as serviceWorker from './service-worker';

// import components
import HomePage from './Pages/Homepage';
import ErrorPages from './Pages/Error';
import ArticlePage from './Pages/Articlepage';
import ExplorePage from './Pages/Explorepage';
import PremiumPage from './Pages/Premium';

ReactDOM.render(
  <BrowserRouter>
    <Switch>
      <Route exact path='/' component={HomePage} />
      <Route exact path={['/explore']} component={ExplorePage} />
      <Route exact path={['/premium']} component={PremiumPage} />
      <Route
        exact
        path={['/premium/payment/success', '/premium/payment/cancel']}
        component={PremiumPage}
      />
      <Route exact path='/:uid' component={HomePage} />
      <Route exact path='/updates/:uid' component={ArticlePage} />
      <Route component={ErrorPages} />
    </Switch>
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN);

// import font
WebFont.load({
  google: {
    families: ['Karla:ital,wght@0,400;0,700;1,400;1,700', 'sans-serif'],
  },
});
